import { render } from "./unreadTopics.vue?vue&type=template&id=6599d55e"
import script from "./unreadTopics.vue?vue&type=script&lang=js"
export * from "./unreadTopics.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__